import { initSentry, Sentry } from '@martha-v5/sentry/browser';
import { useEffect } from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';

initSentry({
  browserTracingIntegration: Sentry.reactRouterV7BrowserTracingIntegration({
    useEffect,
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
  }),
});

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import archieUiCss from '@archieai/ui/css?raw'
const archieUiStyle = document.createElement('style')
archieUiStyle.setAttribute('data-archieai-ui', '')
archieUiStyle.textContent = archieUiCss
document.head.appendChild(archieUiStyle)
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
